<template>
  <bs-detail :filter="filter" :meta="meta" ref="refId" content-class>
    <template slot="data" slot-scope="slot">
      <div
        id="panoDesk"
        style="position: absolute;width: 100%;height: 100vh;left: 0px;top: 0px;overflow: hidden;"
      ></div>
      <div v-show="false" v-text="slot.data.fileUrl"></div>
    </template>
  </bs-detail>
</template>
<script>
export default {
  data() {
    return {
      meta: {
        module: this.$route.params._module,
        field: this.$route.params._field
      },
      filter: {
        artiId: this.$route.params._artiId
      },
      routeType: "arti",
      videoList: [],
      api: null,
      isShowAll: true,
      params: {
        container: document.getElementById("panoDesk"),
        name: "SceneViewer",
        isGyro: true, //默认开启陀螺仪功能  移动端支持陀螺仪设备有效
        isMouseWheel: false, //禁止滚轮缩放
        scenesArr: [
          {
            sceneId: "v1",
            sceneName: "赛车",
            sceneFilePath:
              "//file.whlyw.net/zzwh/vr/yicun/yungenshuyuan/index.m3u8",
            sceneType: "Video"
          }
        ],
        initOverCallBack: function() {
          this.isShowAll = false;
        },
        errorCallBack: function(e) {
          console.log("错误状态：" + e);
        },
        sceneEventClickCallBack: function(e) {
          if (this.isShowAll) {
            this.isShowAll = false;
          } else {
            this.isShowAll = true;
          }
        },
        fsCallBack: function(status, playObj) {
          alert("浏览器不支持全屏！");
        }
      }
    };
  },
  props: {
    result: {
      type: Object
    },
    routeWatch: {
      type: Boolean,
      default: true
    }
  },
  mounted() {
    console.log(this.result);
    if (true) {
      this.videoList.push({
        Text: "超高清",
        Quality: 1,
        Resolution: "2048x1024",
        M3U8:
          "//file.whlyw.net/zzwh/vr/yicun/yungenshuyuan/index.m3u8",
        RTMP: null
      });
    }
    let TBConfig = {
      videoQuality: 1,
      videoList: this.videoList
    };
    initLoad(this.params, function(playMode) {}, TBConfig);
  },
  components: {
    BsDetail: () => import("../../components/bs-detail")
  }
};
</script>

